import { render, staticRenderFns } from "./CalendarListItemLoadingPlaceholder.vue?vue&type=template&id=78bfc69f&"
import script from "./CalendarListItemLoadingPlaceholder.vue?vue&type=script&lang=js&"
export * from "./CalendarListItemLoadingPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.FFR503Cp8cB3/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78bfc69f')) {
      api.createRecord('78bfc69f', component.options)
    } else {
      api.reload('78bfc69f', component.options)
    }
    module.hot.accept("./CalendarListItemLoadingPlaceholder.vue?vue&type=template&id=78bfc69f&", function () {
      api.rerender('78bfc69f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/CalendarList/CalendarListItemLoadingPlaceholder.vue"
export default component.exports